// Sign-in state changes. Current-user data comes from useAuth() (auth/AuthProvider.js).
// A namespace import keeps this module loadable on React Native, where the browser
// persistence options don't exist.
import * as firebaseAuth from 'firebase/auth';
import { auth } from '../firebaseConfig';

/**
 * Sign in with email and password. On the web the session is kept in local storage, so the
 * member stays signed in across tabs and visits until they sign out. (Setting it explicitly
 * also replaces session-only persistence used by earlier versions of the app.)
 */
export async function signIn(email, password) {
  // Browsers only; React Native has no localStorage and keeps its own persistence.
  const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  if (isBrowser && firebaseAuth.browserLocalPersistence) {
    await firebaseAuth.setPersistence(auth, firebaseAuth.browserLocalPersistence);
  }
  return firebaseAuth.signInWithEmailAndPassword(auth, email, password);
}

export function signOutUser() {
  return firebaseAuth.signOut(auth);
}

export function sendPasswordReset(email) {
  return firebaseAuth.sendPasswordResetEmail(auth, email);
}

/** The signed-in Firebase user, or null. Components use useAuth().authUser instead. */
export function getCurrentUser() {
  return auth.currentUser;
}

/** The signed-in user's custom claims ({ member, profileId, admin }), or {} when signed out. */
export async function getCurrentClaims() {
  return auth.currentUser ? (await auth.currentUser.getIdTokenResult()).claims : {};
}
